/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { ProgramID } from "./ProgramID";
import type { ProgramStatus } from "./ProgramStatus";

export interface UpdateUserProgramStatusRequest {
  program: ProgramID;
  status: ProgramStatus;
}
